import { Factory } from 'fishery';
import { Account } from '@trukt/types/Account';
import { NonNullableKeys } from '@trukt/types/NonNullableKeys';
import { addressFactory } from './addressFactory';

const date = 'fakeDate';

export const accountFactory = Factory.define<NonNullableKeys<Required<Account>>>(
  ({ sequence }) => ({
    guid: sequence.toString(),
    rtype: 'client',
    billing: addressFactory.build(),
    createdByGuid: '24',
    dateCreated: date,
    dateDeleted: date,
    dateUpdated: date,
    deletedByGuid: '25',
    email: 'ronald@mcdonald.com',
    isDeleted: false,
    mobileNumber: '(916) 800-8000',
    name: 'McDonalds',
    parentGuid: '26',
    phoneNumber: '(916) 900-9000',
    updatedByGuid: '27',
    website: 'imlovinit.com',
    mc: '',
    usdot: '12345678',
    preferred: false,
    blacklist: false,
    status: 'Approved',
    contacts: [],
    icpGp: 1,
    icpMultiplier: 2,
    slaDays: 3,
    isActive: true,
    orderInstructions:
      'Amet dolores sit tenetur. Illo et aut illum fuga illo assumenda neque. Suscipit officiis assumenda alias aut ut. Id et iure est et perferendis blanditiis asperiores. Unde numquam soluta quis fugit sit quia in reiciendis.',
  }),
);
